var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "visit-medicaments"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-prescription', {
    attrs: {
      "do-update": _vm.reloadPrescription,
      "clientId": _vm.clientId,
      "visitId": _vm.visitId
    },
    on: {
      "updated": _vm.updatePrescriptionDone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.pharmAnamnesis || _vm.allergicAnamnesis) ? _c('div', {
    staticClass: "card-body bg-danger-light"
  }, [(_vm.allergicAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.allergicAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.allergicAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.allergicAnamnesis.text)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.pharmAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.pharmAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.pharmAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pharmAnamnesis.text)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('add-medicament', {
    attrs: {
      "client-id": _vm.clientId,
      "visit-id": _vm.visitId,
      "visiv-on:update": _vm.updateMedicament,
      "copied-medicament": _vm.medicamentToCopy
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-light"
  }, [_c('list-previous-medicament', {
    on: {
      "copied": _vm.copyMedicament
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083c3968","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/VisitMedicament.vue
// module id = 577
// module chunks = 0